/**
 * Metadados de item que várias vistas mostram — e que não pertencem a nenhuma delas.
 *
 * Isto morava no laboratório, e o montador e o mapa o importavam de lá. Enquanto fosse
 * assim, esconder a bancada de autoria do público derrubava as outras duas telas junto.
 */

import type { AnyTemplate } from '../engine/registry.ts';
import type { InteractivityLevel } from '../schema/item.ts';
import { SKILLS, type MatrixSkill } from '../schema/skills.gen.ts';
import type { SkillMeta } from '../schema/taxonomy.ts';

/** O que cada nível de interatividade significa, em palavras. */
export const NIVEL_TXT: Readonly<Record<InteractivityLevel, string>> = {
  N0: 'Texto na tela',
  N1: 'Figura gerada',
  N2: 'Animação ou manipulação',
  N3: 'Marcação na figura',
  N4: 'Construção com ferramentas',
};

/** A habilidade da matriz de um item, quando o código estiver nela. */
export function habilidadeDe(t: AnyTemplate): SkillMeta | undefined {
  const codigo = t.skills[0] as string | undefined;
  return codigo ? SKILLS[codigo as MatrixSkill] : undefined;
}
